import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import React, { Component } from 'react'
import { addURL } from 'redux/actions/url'
import Form from 'devextreme-react/form'
import ModalAksesMenu from 'components/pages/modal/participant/admin/user/aksesMenu'
import ModalEditUser from 'components/pages/modal/participant/admin/user/editUser'
import { getUser, participants } from 'dataSource/lookup'
import Notes from 'components/pages/modal/participant/admin/note'
import httpRequest from 'plugin/httprequest'
import notify from 'devextreme/ui/notify'

class UserParticipant extends Component {
  constructor(props) {
    super(props)
    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0

    this.state = {
      filterData: {
        participantId: this.participantId,
      },
    }

    this.formFilterRef = React.createRef()
    this.dataGridRef = React.createRef()
    this.modalUserRef = React.createRef()
    this.modalAkasesMenuRef = React.createRef()
    this.modalSuspendRef = React.createRef()
    this.modalDeactiveRef = React.createRef()
    this.modalActiveRef = React.createRef()
    this.modalDeleteRef = React.createRef()

    this.columns = [
      {
        type: 'buttons',
        buttons: [
          'edit',
          {
            text: 'Ubah',
            hint: 'edit',
            onClick: (e) => {
              this.showModal(e.row.data, 'edit')
            },
          },
          {
            text: 'Suspend',
            hint: 'edit',
            onClick: (e) => {
              this.modalSuspendRef.current.show()
              this.modalSuspendRef.current.retrieveData(e.row.data)
            },
          },
          {
            text: 'Aktive',
            hint: 'edit',
            onClick: (e) => {
              this.modalActiveRef.current.show()
              this.modalActiveRef.current.retrieveData(e.row.data)
            },
          },
          {
            text: 'Non Aktive',
            hint: 'edit',
            onClick: (e) => {
              this.modalDeactiveRef.current.show()
              this.modalDeactiveRef.current.retrieveData(e.row.data)
            },
          },
          {
            text: 'Akses Menu',
            hint: 'edit',
            onClick: (e) => {
              this.modalAkasesMenuRef.current.show()
              this.modalAkasesMenuRef.current.retrieveData(e.row.data)
            },
          },

          {
            text: 'Hapus',
            hint: 'edit',
            onClick: (e) => {
              this.modalDeleteRef.current.show()
              this.modalDeleteRef.current.retrieveData(e.row.data)
            },
          },
        ],
      },
      {
        dataField: 'no',
        caption: 'No.',
        alignment: 'center',
        width: '50px',
        cellRender: (e) => {
          return e.rowIndex + 1
        },
      },

      {
        dataField: 'username',
        caption: 'Username',
      },
      {
        dataField: 'firstName',
        caption: 'Nama Awal',
      },
      {
        dataField: 'lastName',
        caption: 'Nama Akhir',
      },
      {
        dataField: 'email',
        caption: 'Email',
      },
      {
        dataField: 'userParentId',
        caption: 'Supervisor',
        lookup: {
          dataSource: getUser(this.props.store, this.participantId),
          valueExpr: 'id',
          displayExpr: 'username',
        },
      },
      {
        dataField: 'status',
        caption: 'Status',
        lookup: {
          dataSource: [
            {
              id: 'ACTIVE',
              value: 'Active',
            },
            {
              id: 'SUSPEND',
              value: 'Suspend',
            },
            {
              id: 'INACTIVE',
              value: 'Non Active',
            },
          ],
          valueExpr: 'id',
          displayExpr: 'value',
        },
      },
    ]

    this.formFilter = [
      {
        dataField: 'participantId',
        label: {
          text: 'Participant',
        },
        editorType: 'dxSelectBox',
        editorOptions: {
          dataSource: participants(this.props.store),
          elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
          valueExpr: 'id',
          displayExpr: 'participantName',
          readOnly: true,
        },
      },
    ]
  }

  componentWillMount() {
    let store = this.props.store
    store.dispatch(addURL(this.props.location.pathname))
  }

  showModal = async (data, type) => {
    this.modalUserRef.current.show(data, type)
  }

  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'plus',
        text: 'Tambah User',
        elementAttr: { class: 'bg-button-add-dapen-default' },
        onClick: (e) => {
          this.showModal(null, 'add')
        },
      },
    })
  }

  deleteData = async (data) => {
    await httpRequest(
      process.env.REACT_APP_BACKEND_HRD,
      this.props.store,
      `wp​/participant-users​/${this.participantId}/${data.id}`,
      'DELETE'
    )

    this.forceRefresh()
    notify(
      {
        message: 'Sukses Hapus Data',
        width: 'AUTO',
        shading: true,
        position: { at: 'center', my: 'center', of: window },
      },
      'success',
      1000
    )
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  render() {
    return (
      <div className="container-fluid">
        <h2 className="main-title">Daftar User</h2>
        <div className="row">
          <div className="col-md-6">
            <Form
              id={'formHeader'}
              formData={this.state.filterData}
              ref={this.formFilterRef}
              items={this.formFilter}
              labelLocation={'left'}
            />
          </div>
        </div>

        <DevExpressDataGrid
          ref={this.dataGridRef}
          loadAPI={`wp/participant-users/${this.participantId}`}
          insertAPI="-"
          updateAPI="-"
          deleteAPI="-"
          backendserver={process.env.REACT_APP_BACKEND}
          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}
          exportExcel={false}
          exportFileName={'Participant'}
          allowExportSelectedData={true}
          selection={'multiple'}
          showBorders={true}
          paging={true}
          defaultPageSize={10}
          height={'75vh'}
          popupTitle={'Participant'}
          popupWidth={700}
          popupHeight={500}
          popupFormLabelLocation="left"
          popupFormMinColWidth={300}
          popupFormColCount={3}
          ColumnChooser={true}
          ColumnFixing={true}
          FilterRow={true}
          ColumnConfiguration={this.columns}
          SummaryConfiguration={this.summary}
          onToolbarPreparing={this.onToolbarPreparing}
          store={this.props.store}
        />

        <ModalAksesMenu
          ref={this.modalAkasesMenuRef}
          store={this.props.store}
          participantId={this.participantId}
        />
        <ModalEditUser
          ref={this.modalUserRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
        />
        <Notes
          ref={this.modalSuspendRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          action={'suspend'}
        />
        <Notes
          ref={this.modalDeactiveRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          action={'deactive'}
        />
        <Notes
          ref={this.modalActiveRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          action={'active'}
        />
        <Notes
          ref={this.modalDeleteRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
          action={'delete'}
        />
      </div>
    )
  }
}

export default UserParticipant
